module.exports = __webpack_public_path__ + "frontend-assets/img/circles.0688b87b.png";